module.exports = __webpack_public_path__ + "assets/img/neutral_girl.3bfb07f9.jpg";